import { getArgsAsTypesafeObjectProperties } from '../constants-util';

export const constants = getArgsAsTypesafeObjectProperties(
	'GET_USERSETTINGS',
	'UPSERT_USERSETTINGS'
);
